module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.consulta) ? _c('el-tabs', {
    attrs: {
      "type": "border-card"
    },
    model: {
      value: (_vm.tabSelected),
      callback: function($$v) {
        _vm.tabSelected = $$v
      },
      expression: "tabSelected"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "Imprimir ASO",
      "name": "tab-aso"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-print"
  }), _vm._v(" Imprimir ASO")]), _vm._v(" "), _c('Aso', {
    attrs: {
      "consulta": _vm.consulta
    }
  })], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": " Imprimir Ficha Clínica",
      "name": "tab-femo"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-print"
  }), _vm._v(" Imprimir Ficha Clínica")]), _vm._v(" "), _c('Femo', {
    attrs: {
      "consulta": _vm.consulta
    }
  })], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": " Liberar ASO",
      "name": "tab-liberar"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-lock"
  }), _vm._v(" Liberar ASO")]), _vm._v(" "), _c('Liberar', {
    attrs: {
      "consulta": _vm.consulta
    }
  })], 1), _vm._v(" "), (!_vm.consulta || (_vm.consulta && _vm.consulta.tipo_status && _vm.consulta.tipo_status.id != 66 && _vm.consulta.tipo_status.id != 57 && _vm.consulta.tipo_status.id != 58)) ? _c('el-tab-pane', {
    attrs: {
      "label": "Cancelar Consulta",
      "name": "tab-cancelar"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-window-close"
  }), _vm._v(" Cancelar Consulta")]), _vm._v(" "), _c('Cancelar', {
    attrs: {
      "consulta": _vm.consulta
    }
  })], 1) : _vm._e()], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-211243cc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/credenciada/consulta/configuracao/index.vue
// module id = 1457
// module chunks = 45